import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CheckModule {
    canAccess(path: string): boolean {
        return !!path;
    }
}
